var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\n  #define IN in\n  #define OUT out\n#else\n  #define IN attribute\n  #define OUT varying\n#endif';
return __p;
};
fn.toString=fn;
module.exports = fn;